"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductFamily = void 0;
var ProductFamily;
(function (ProductFamily) {
    ProductFamily["CONVENTIONAL"] = "CONVENTIONAL";
    ProductFamily["HOME_POSSIBLE"] = "HOME_POSSIBLE";
    ProductFamily["FHA"] = "FHA";
    ProductFamily["VA"] = "VA";
    ProductFamily["JUMBO"] = "JUMBO";
    ProductFamily["INVESTMENT"] = "INVESTMENT";
    ProductFamily["HOME_EQUITY"] = "Home Equity";
    ProductFamily["USDA"] = "USDA";
})(ProductFamily = exports.ProductFamily || (exports.ProductFamily = {}));
